(function () {
  var GetCorePage = function () {
    var wireframes = document.getElementsByClassName("pxFormGenerator");
    form_url = 'https://formbuilder.hulkapps.com';
    //console.log('wireframes', wireframes.length);
    if (wireframes.length > 0) {
      //console.log('wireframes', wireframes);
      for (var i = 0; i < wireframes.length; i++) {
        curFrame = wireframes[i];
        if (curFrame.id) {
          var curfrm = document.getElementById('frame_' + curFrame.id);
          var available_iframe = document.getElementById(curFrame.id).innerHTML;

          if (available_iframe.indexOf('iframe') === -1) {
            var hulk_regexp = /(?!&)utm_[^=]*=[^&]*(?=)/g;
            var hulk_utm_matches = location.search.substr(1).match(hulk_regexp);
            var hulk_utm_params = '';
            if (hulk_utm_matches != undefined) {
              hulk_utm_params = hulk_utm_matches.join('&');
            }
            var hulk_referrer_url = location.href.trim();
            console.log('hulk_referrer_url',hulk_referrer_url);
            var str = '';
            if (hulk_utm_params) {
              hulk_utm_params = hulk_utm_params.includes("utm_source") ? hulk_utm_params : 'utm_source=hulkapps-form-builder-app&' + hulk_utm_params
              str = '<iframe src="' + form_url + '/corepage/customform?id=' + curFrame.id + '&referrer_url='+hulk_referrer_url+'&' + hulk_utm_params + '" id="frame_' + curFrame.id + '" frameborder="0" width="100%">';
            } else {
              str = '<iframe src="' + form_url + '/corepage/customform?id='+curFrame.id+'&referrer_url='+hulk_referrer_url+'" id="frame_' + curFrame.id + '" frameborder="0" width="100%">';
            }
            document.getElementById(curFrame.id).innerHTML = str;
          }
          frame_resize(curFrame.id);
        }
      }
    }

    function frame_resize(id) {
      var iframes = document.getElementsByClassName("pxFormGenerator");
      if (iframes.length > 0) {
        for (var i = 0; i < iframes.length; i++) {
          var width = document.getElementById(id).style.width;
          var formId = id;
          var divId = 'frame_' + id;
          var zino_resize = function (event) {
            if (event.origin !== form_url) {
              return;
            }
            var zino_iframe = document.getElementById(divId);
            if (zino_iframe) {
              if (event.data['formid'] == formId) {
                zino_iframe.style.height = event.data['height'] + "px";
                if (event.data['scroll_to'] == true) {
                  const formElement = document.querySelector('#frame_' + formId);
                  const formRect = formElement.getBoundingClientRect();
                  const targetOffset = formElement.offsetTop > 0 ? formElement.offsetTop - 50 : 0.80 * (formRect.top + window.scrollY);
                  const duration = 1000;

                  const startTime = performance.now();
                  const startScrollOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

                  function scrollToTarget(currentTime) {
                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const easing = easeInOutCubic(progress);
                    const scrollOffset = startScrollOffset + (targetOffset - startScrollOffset) * easing;

                    window.scrollTo(0, scrollOffset);

                    if (elapsed < duration) {
                      requestAnimationFrame(scrollToTarget);
                    }
                  }

                  function easeInOutCubic(t) {
                    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                  }

                  requestAnimationFrame(scrollToTarget);
                }
              }
            }
          };
          if (window.addEventListener) {
            window.addEventListener("message", zino_resize, false);
          } else if (window.attachEvent) {
            window.attachEvent("onmessage", zino_resize);
          }
        }
      }
    }
  }
  setTimeout(function () {
    GetCorePage();
  });


})();  